module.exports = __webpack_public_path__ + "static/media/sushi.c617c197.jpg";